import { VehicleType2 } from '../../store/facade/facadeApiV3';

export type Props = {
    isBev: boolean;
    assetType?: VehicleType2;
};

export const VehicleIcon = ({ isBev, assetType }: Props) => {
    const getAssetIcon = () => {
        switch (assetType) {
            case VehicleType2.Truck:
                return 'rioglyph-truck';
            case VehicleType2.Bus:
                return 'rioglyph-bus';
            case VehicleType2.Van:
                return 'rioglyph-van';
            case VehicleType2.Trailer:
                return 'rioglyph-trailer';
            default:
                return 'rioglyph rioglyph-truck-breakdown';
        }
    };

    return (
        <div className='margin-right-10'>
            {isBev ? (
                <span className='rioglyph-icon-pair' data-testid='asset-bev-icon'>
                    <span className={`rioglyph ${getAssetIcon()} text-size-16`} />
                    <span className='rioglyph rioglyph-fuel-electric' />
                </span>
            ) : (
                <span className={`rioglyph ${getAssetIcon()} text-size-16`} data-testid='asset-ice-icon' />
            )}
        </div>
    );
};
